import * as React from 'react'

export const Location = () => (
  <svg
    width="70"
    height="70"
    viewBox="0 0 70 70"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M59.1571 42.0791L53.7294 39.0215L50.4761 52.9658L64.3164 66.9101L67.5314 68.7213C68.3941 69.2074 69.3922 68.3488 69.0409 67.4232L59.6273 42.6257C59.5394 42.3942 59.373 42.2007 59.1571 42.0791Z"
      fill="#85A4A7"
    />
    <path
      d="M47.2457 35.3691L41.4229 47.8223L52.5392 60.2754L64.3163 66.9104L53.7294 39.0218L47.2457 35.3691Z"
      fill="#A1C0C3"
    />
    <path
      d="M47.2456 35.3691L35 42.2676L28.6478 56.1339L35 70.0002C35.1791 70.0002 35.3584 69.9547 35.5196 69.8638L52.5391 60.2754L47.2456 35.3691Z"
      fill="#BCDBDE"
    />
    <path
      d="M22.7545 35.3691L11.6412 47.8223L17.461 60.2754L34.4805 69.8638C34.6418 69.9547 34.8209 70.0002 35.0001 70.0002V42.2676L22.7545 35.3691Z"
      fill="#A1C0C3"
    />
    <path
      d="M22.7544 35.3691L17.461 60.2754L2.4688 68.7217C1.60617 69.2077 0.608033 68.3492 0.95938 67.4236L10.3728 42.6262C10.4607 42.3945 10.627 42.2011 10.843 42.0795L22.7544 35.3691Z"
      fill="#BCDBDE"
    />
    <path
      d="M35 0V52.9349C35.7544 52.9349 36.4147 52.5392 36.7898 51.9454C36.7923 51.9454 51.1309 29.2074 51.1309 29.2074C52.9831 26.2683 54.0566 22.788 54.0566 19.0566C54.0566 8.53198 45.5246 0 35 0Z"
      fill="#668386"
    />
    <path
      d="M36.392 51.9454C36.394 51.9454 47.5463 29.2074 47.5463 29.2074C48.9869 26.2683 49.8218 22.788 49.8218 19.0566C49.8218 8.53198 43.1859 0 35.0001 0C24.4753 0 15.9435 8.53198 15.9435 19.0566C15.9435 22.788 17.0169 26.2684 18.8704 29.2074C18.869 29.2074 33.2076 51.9454 33.2076 51.9454C33.5852 52.5392 34.2457 52.9349 34.9999 52.9349C35.5867 52.9349 36.1004 52.5392 36.392 51.9454Z"
      fill="#7B9A9D"
    />
    <path
      d="M35.0001 29.6427C40.8471 29.6427 45.5871 24.9028 45.5871 19.0557C45.5871 13.2087 40.8471 8.46875 35.0001 8.46875C29.153 8.46875 24.4131 13.2087 24.4131 19.0557C24.4131 24.9028 29.153 29.6427 35.0001 29.6427Z"
      fill="#527174"
    />
    <path
      d="M35 12.7051V25.4095C38.5083 25.4095 41.3522 22.5655 41.3522 19.0573C41.3522 15.549 38.5083 12.7051 35 12.7051Z"
      fill="#9BBABD"
    />
    <path
      d="M37.1174 19.0573C37.1174 15.549 36.1694 12.7051 35 12.7051C31.4918 12.7051 28.6478 15.549 28.6478 19.0573C28.6478 22.5655 31.4918 25.4095 35 25.4095C36.1694 25.4095 37.1174 22.5655 37.1174 19.0573Z"
      fill="#BEDDE0"
    />
  </svg>
)
